<template>
  <div class="quick-set">
    <div class="quick-set-operation">
      <el-button @click="handleAdd" type="primary">新增规则</el-button>
      <el-button @click="debounceSave" type="primary">保存修改</el-button>
    </div>

    <div class="quick-set-content">
      <template v-for="(item, index) in form">
        <div style="width: 100%;background: #eee;height: 1px"></div>
        <div class="quick-set-content-item">
          <div class="quick-set-content-item-name">
            <el-input
                style="width: 100%"
                autosize
                type="textarea"
                placeholder="请输入规则名称"
                v-model="item.name"
                maxlength="15"
                show-word-limit
                :rows="3"/>
          </div>

          <div class="quick-set-content-item-ids">
            <el-input
                style="width: 100%"
                :autosize="{ minRows: 8, maxRows: 10}"
                type="textarea"
                placeholder="放空则不限制影厅，多个编码使用英文逗号隔开"
                v-model="item.standardIds"/>
          </div>
          <div class="quick-set-content-item-form">
            <div class="quick-set-content-item-form-radio">
              <div>退票方式：</div>
              <el-radio v-model="item.way" :label="0">自主退票</el-radio>
              <el-radio v-model="item.way" :label="1">联系客服</el-radio>
            </div>
            <div class="quick-set-content-item-form-radio">
              <div>退票手续费：</div>
              <el-radio v-model="item.canRefund" :label="0">不支持退票</el-radio>
              <el-radio v-model="item.canRefund" :label="1">可退票</el-radio>
            </div>

            <el-form class="quick-set-content-item-form-rule-list">
              <div class="quick-set-content-item-form-rule-list-item" v-for="rule in item.itemList">
                  <el-form-item :error="rule.error">
                    <div class="quick-set-content-item-form-rule-list-item-font">
                      <div>开场前</div>
                      <el-input
                          @input="(val) => handleInput(rule, 'startHour' ,val)"
                          style="width: 50px"
                          v-model="rule.startHour"
                          @blur="clearRule(rule)"
                      />
                      <div>-</div>
                      <el-input
                          @input="(val) => handleInput(rule, 'endHour' ,val)"
                          style="width: 50px"
                          v-model="rule.endHour"
                          @blur="clearRule(rule)"
                      />
                      <div>小时</div>
                    </div>
                  </el-form-item>
                <div class="quick-set-content-item-form-rule-list-item-radio">
                  <div class="quick-set-content-item-form-rule-list-item-radio-item">
                    <el-radio v-model="rule.way" :label="0">不支持退票</el-radio>
                  </div>
                  <div class="quick-set-content-item-form-rule-list-item-radio-item">
                    <el-radio @input="(val)=> handleRadioFromRate(item, val)" v-model="rule.way" :label="1">收取</el-radio>
                    <el-input
                        style="width: 130px"
                        v-model="rule.feeRate"
                        :disabled="rule.way !== 1"
                        @input="(val) => handleInput(rule, 'feeRate' ,val)"
                        @blur="handleBlurFreeRate(item)"
                    >
                      <template #append>%</template>
                    </el-input>
                  </div>
                  <div class="quick-set-content-item-form-rule-list-item-radio-item">
                    <el-radio @input="(val)=> handleRadioFromFixed(item, val)" v-model="rule.way" :label="2">收取</el-radio>
                    <el-input
                        style="width: 150px"
                        v-model="rule.feeFixed"
                        :disabled="rule.way !== 2"
                        @input="(val) => handleInput(rule, 'feeFixed' ,val)"
                        @blur="handleBlurFreeFixed(item)"
                    >
                      <template #append>元/张</template>
                    </el-input>
                    <div>退票手续费</div>
                  </div>
                </div>
              </div>
            </el-form>
            <div class="quick-set-content-item-form-max">
              <div>最高</div>
              <el-input
                  v-if="item.maxFeeUnit === 0"
                  style="width: 200px"
                  placeholder="请输入内容"
                  v-model="item.maxFeeRate"
                  @input="(val) => handleInput(item, 'maxFeeRate' ,val)"
              >
                <template slot="append">%</template>
              </el-input>
              <el-input
                  v-if="item.maxFeeUnit === 1"
                  style="width: 200px"
                  placeholder="请输入内容"
                  v-model="item.maxFeeRate"
                  @input="(val) => handleInput(item, 'maxFeeRate' ,val)"
              >
                <template slot="append">元/张</template>
              </el-input>
            </div>
          </div>

          <div v-if="item.defaultRule === 0" class="quick-set-content-item-operation">
            <el-button @click="handleRemove(item,index)" type="danger">删除</el-button>
            <el-button v-if="item.status === 0" @click="handleUse(item, 1)" type="primary">暂停使用</el-button>
            <el-button v-else @click="handleUse(item, 0)" type="info">启用规则</el-button>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import QuickSet from "@/api/quick-set";
const quickApis = new QuickSet();


function isNoBlank(str) {
  return str !== null && str !== "";
}

export default {
  data() {
    return {
      form: []
    }
  },
  methods: {
    handleBlurFreeRate(item){
      const sorts = item.itemList.filter(el => el.feeRate).sort((a, b) => {
        return b.feeRate - a.feeRate;
      })
      console.log('rate', sorts)
      if(item.maxFeeRate < sorts[0].feeRate || !item.maxFeeRate){
        item.maxFeeRate = sorts[0].feeRate || 0
      }
    },
    handleBlurFreeFixed(item){
      const sorts = item.itemList.filter(el => el.feeFixed).sort((a, b) => {
        return b.feeFixed - a.feeFixed;
      })
      console.log('fixed', sorts)
      if(item.maxFeeRate < sorts[0].feeFixed || !item.feeFixed){
        item.maxFeeRate = sorts[0].feeFixed || 0
      }
    },
    async validate(){
      let errorMessage = ''
      this.form.map(item =>{
        if(!item.name){
          errorMessage = '规则名称不能为空'
          return;
        }

        const names = this.form.map(el => el.name)
        const isRepeat = names.filter(el => el === item.name).length > 1
        if(isRepeat){
          errorMessage = '规则名称不能为重复'
          return;
        }

        const hasOne = item.itemList.some(item =>{
          return isNoBlank(item.startHour) && isNoBlank(item.endHour) && (item.startHour + item.endHour > 0)
        })

        if(!hasOne){
          item.itemList[0].error = '请填写一项开始和截止时间'
          errorMessage = '请填写一项开始和截止时间'
          return;
        }

        const invalid = item.itemList.find(item => {
          return isNoBlank(item.endHour) && !isNoBlank(item.startHour);
        });

        if (invalid) {
          invalid.error = '存在截止时间但未填写开始时间'
          errorMessage = '存在截止时间但未填写开始时间';
          return;
        }

        const invalidIndex = item.itemList.findIndex(item => {
          const startFilled = isNoBlank(item.startHour) && isNoBlank(item.endHour);
          const hasValue = Number(item.startHour) + Number(item.endHour) > 0;

          if (startFilled && hasValue) {
            return Number(item.startHour) > Number(item.endHour); // ❌ 不合法：开始时间 > 截止时间
          }
          return false;
        });

        if (invalidIndex !== -1) {
          item.itemList[invalidIndex].error = '截止时间不能小于开始时间'
          errorMessage = `截止时间不能小于开始时间`;
          return;
        }

        function validateSequentialTimeSlots(list) {
          for (let i = 1; i < list.length; i++) {
            const prevEnd = list[i - 1].endHour;
            const currStart = list[i].startHour;

            // 如果两个都有值，则必须相等（注意转换为数字）
            if (prevEnd !== "" && currStart !== "") {
              if (Number(currStart) !== Number(prevEnd)) {
                return i;
              }
            }
          }
          return -1;
        }

        const tempIndex = validateSequentialTimeSlots(item.itemList)
        if(tempIndex !== -1){
          item.itemList[tempIndex].error = '开始时间必须等于上一个截止时间'
          errorMessage = `开始时间必须等于上一个截止时间`;
          return;
        }
      })

      if(errorMessage){
        this.$message.error(errorMessage)
        return Promise.reject(errorMessage)
      }
      return Promise.resolve()
    },
    async refresh(){
      const { data } = await quickApis.getList({
        appKey:localStorage.getItem("appKeyMini"),
        type:1
      })
      if(!data.success){
        this.$message.error(data.message)
      }
      this.form = data.data.map(item=>{
        if(!item.itemList){
          item.itemList = []
        }

        if(item.itemList.length < 4){
          Array.from({length: 4 - item.itemList.length}).forEach(_=>{
            item.itemList.push(this.createItemListElement())
          })
        }

        item.itemList.forEach(item =>{
          item.error = ''
        })

        return item
      })
    },
    createItemListElement(){
      return {
        endHour: '',
        feeFixed: '',
        feeRate: '',
        id: '',
        refundRuleId: 0,
        startHour: '',
        way: 0
      }
    },
    createFormItem(){
      const form = {
        appKey: localStorage.getItem('appKeyMini'),
        name: '',
        standardIds:'',
        canRefund: 0,
        refundType: 1,
        maxFeeRate: 0, // 最高
        maxFeeUnit: 0, // 单位
        status:0,
        itemList:[],
        defaultRule: 0,
        way:0,
      }

      Array.from({length: 4}).forEach(_=>{
        form.itemList.push(this.createItemListElement())
      })

      form.itemList.forEach(item => {
        item.error = ''
      })
      return form
    },
    handleInput(input,key, val){
      input[key] = val.replace(/\D/g, ''); // 移除非数字字符
    },
    handleAdd(){
      const temp = this.createFormItem()
      this.form.unshift(temp)
    },
    clearRule(rule){
      rule.error = ''
    },
    debounceSave(){
      debounce(()=>{
        this.handleSave()
      },500, true)
    },
    async handleSave(){
      await this.validate();
      const params = this.form.map(item=>{
        return item
      })

      const { data } = await quickApis.save(params)
      if(!data.success){
        this.$message.error(data.message)
        return;
      }
      this.$message({
        message: '保存成功',
        type:'success'
      })

      this.refresh()
    },
    async handleRemove(item, index){
      // 远程删除
      await this.$confirm(`是否确认删除`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      // 本地删除
      if(!item.id){
        this.form.splice(index,1)
        return;
      }
      quickApis.delete({id: item.id}).then(res=>{
        if(res.data.code === 200){
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.form.splice(index,1)
          return;
        }
        this.$message.error(res.data.message)
      })

    },
    async handleUse(item, status){
      await this.$confirm(`是否确认${status? '暂停使用该规则':'启用该规则'}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      if(!item.id){
        item.status = status
        return;
      }
      const ret = await quickApis.switch({
        id: item.id,
        status: status
      })

      if(ret.data.code === 200){
        this.$message({
          message: '操作成功',
          type:'success'
        })
        item.status = status
        return;
      }
      this.$message.error(ret.data.message)
    },
    handleRadioFromRate(item, val){
      item.itemList.forEach(rule =>{
        if(rule.way !== 0)
        rule.way = val
      })
      item.maxFeeRate = [...item.itemList].sort((rule1,rule2)=> (rule2.feeRate || 0) - (rule1.feeRate || 0))[0].feeRate
      item.maxFeeUnit = 0
    },
    handleRadioFromFixed(item, val){
      item.itemList.forEach(rule =>{
        if(rule.way !== 0)
        rule.way = val
      })
      item.maxFeeRate = [...item.itemList].sort((rule1,rule2)=> (rule2.feeFixed || 0) - (rule1.feeFixed || 0))[0].feeFixed
      item.maxFeeUnit = 1
    },
  },
  async created(){
    this.refresh()
  }
}
</script>

<style scoped lang="less">
.el-form-item{
  margin-bottom: 0px;
}
.quick-set{
  display: flex;
  flex-direction: column;


  .quick-set-content{
    margin-top: 20px;
    display: flex;
    gap: 10px;
    flex-direction: column;

    .quick-set-content-item {
      flex: 1;
      display: flex;
      flex-direction: row;
      gap: 10px;

      .quick-set-content-item-name{
        min-width: 140px;
      }
      .quick-set-content-item-ids{
        min-width: 200px;
      }
      .quick-set-content-item-form{
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: 10px;
        min-width: 850px;

        .quick-set-content-item-form-radio{
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .quick-set-content-item-form-max{
          margin-top: 14px;
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .quick-set-content-item-form-rule-list{
          display: flex;
          flex-direction: column;
          gap: 10px;

          .quick-set-content-item-form-rule-list-item{
            display: flex;

            .quick-set-content-item-form-rule-list-item-font{
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 10px;
            }
            .quick-set-content-item-form-rule-list-item-radio{
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 26px;
              margin-left: 10px;
              .quick-set-content-item-form-rule-list-item-radio-item{
                .el-radio{
                  margin-right: 5px
                }
                display: flex;
                flex-direction: row;
                align-items: center;
              }
            }
          }
        }
      }
      .quick-set-content-item-operation{
        width: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/set/quickSet.vue